module.exports = __webpack_public_path__ + "static/media/TradeGecko.55efb6fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TradeGecko.png
// module id = 79
// module chunks = 0